<template>
  <div class="rf-rc-settingss-left rf-rc-col1">
    <div class="promo-design-group flex flex-col gap-4">
      <div class="flex flex-col">
        <v-checkbox
          v-if="enhancedHtmlCondition"
          v-model="model.filter.enhanced_html_mode"
          label="Enhanced HTML Mode"
          hideDetails
          class="mb-8"
        ></v-checkbox>
        <RfHtmlFieldEditor
          v-model="
            (currentTranslations.hasOwnProperty('rf_retention_title') ? previewActions : actions)
              .rf_retention_title
          "
          :rows="2"
          label="Title"
          name="title"
          :enhancedHtml="enhancedHtmlActive"
          :disabled="currentTranslations.hasOwnProperty('rf_retention_title')"
        />
        <RfInsertUserTrait
          v-if="!currentTranslations.hasOwnProperty('rf_retention_title')"
          :app="app"
          actionName="rf_retention_title"
          title="title"
          :actions="actions"
        />
      </div>
      <div v-if="!noStyle" class="promo-fonts-size-input">
        <v-text-field
          v-model.trim="actions.rf_settings_title_font_size"
          variant="outlined"
          density="compact"
          persistentPlaceholder
          label="Title Font Size"
          name="title-font-size"
          required
          hideDetails
        ></v-text-field>
        <v-text-field
          v-model.trim="actions.rf_settings_fill_color"
          variant="outlined"
          density="compact"
          persistentPlaceholder
          label="Font Color"
          name="fill_color"
          required
          hideDetails
          @blur="actions.rf_settings_fill_color = extendHex(actions.rf_settings_fill_color)"
        ></v-text-field>
      </div>
      <div class="flex flex-col">
        <RfHtmlFieldEditor
          v-model="
            (currentTranslations.hasOwnProperty('rf_retention_message') ? previewActions : actions)
              .rf_retention_message
          "
          :rows="model.path_type === 'retention_modal' ? 4 : 3"
          label="Message"
          name="message"
          :enhancedHtml="enhancedHtmlActive"
          :disabled="currentTranslations.hasOwnProperty('rf_retention_message')"
        />
        <RfInsertUserTrait
          v-if="!currentTranslations.hasOwnProperty('rf_retention_message')"
          :app="app"
          actionName="rf_retention_message"
          title="message"
          :actions="actions"
        />
      </div>
      <template v-if="!noStyle">
        <div class="promo-fonts-size-input">
          <v-text-field
            v-model.trim="actions.rf_settings_message_font_size"
            variant="outlined"
            density="compact"
            persistentPlaceholder
            label="Font Size"
            name="message-font-size"
            required
            hideDetails
          ></v-text-field>
          <v-select
            v-model="actions.rf_retention_align"
            variant="outlined"
            hideDetails
            density="compact"
            label="Align"
            itemTitle="text"
            :items="[
              { value: 'left', text: 'Left' },
              { value: 'center', text: 'Center' },
              { value: 'right', text: 'Right' },
            ]"
          />
          <v-text-field
            v-if="model.path_type !== 'email'"
            v-model.trim="actions.rf_settings_title_padding_top"
            variant="outlined"
            hideDetails
            density="compact"
            persistentPlaceholder
            label="Top Padding"
            name="top_padding"
          ></v-text-field>
        </div>
        <div v-if="isDeviceInterstitial" class="promo-fonts-size-input">
          <RfInputWithMeasures
            v-model="paddingValue"
            :measures="DEVICES_MEASURES"
            label="Side padding"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import RfInsertUserTrait from "@/components/RfPathCreate/RfRetentionActions/RfInsertUserTrait.vue";
import RfHtmlFieldEditor from "@/components/RfPathCreate/RfRetentionActions/components/RfHtmlFieldEditor.vue";
import LanguagePreviewMixin from "@/utils/LanguagePreviewMixin";
import { isEnhancedHTMLActive, supportsEnhancedHTML } from "@/utils/prompts/promptHelpers";
import { PromptTypes } from "@/utils/constants/PromoTypesConstants";
import { DefaultDeviceOptions } from "@/utils/constants/DevicesConstants";
import { computed } from "vue";
import { DEVICES_MEASURES, useCSSProperty } from "@/utils/composables/useCSSProperty";
import RfInputWithMeasures from "@/components/legacy/RfInputWithMeasuresLegacy.vue";
import { extendHex } from "@/utils/colorHelpers";

export default {
  name: "RfRetentionActionTitleMessage",
  components: { RfInsertUserTrait, RfInputWithMeasures, RfHtmlFieldEditor },
  mixins: [LanguagePreviewMixin],
  props: {
    actions: Object,
    model: Object,
    app: Object,
    noStyle: { type: Boolean, default: false },
  },
  setup: props => {
    const { variable: paddingValue } = useCSSProperty(
      () => props.actions,
      "rf_settings_body_padding_side",
    );

    const isDeviceInterstitial = computed(() => {
      return (
        props.model.path_type === PromptTypes.interstitial.value &&
        [DefaultDeviceOptions.android_os.value, DefaultDeviceOptions.ios.value].includes(
          props.model.device_type,
        )
      );
    });

    const enhancedHtmlCondition = computed(() => supportsEnhancedHTML(props.model, props.app));
    const enhancedHtmlActive = computed(() => isEnhancedHTMLActive(props.model, props.app));
    return {
      isDeviceInterstitial,
      DEVICES_MEASURES,
      paddingValue,
      enhancedHtmlCondition,
      enhancedHtmlActive,
      extendHex,
    };
  },
};
</script>
